import type { PlatformBrandFont } from 'src/types';

export const CourseStatusValues = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export const CourseAccessValues = {
  PRIVATE: 'private',
  FREE: 'free',
  PAID: 'paid',
} as const;

export type CourseStatus = keyof typeof CourseStatusValues;
export type CourseStatusValue = (typeof CourseStatusValues)[CourseStatus];

export type CourseAccess = keyof typeof CourseAccessValues;
export type CourseAccessValue = (typeof CourseAccessValues)[CourseAccess];

// later will be removed
export const COOKIE_MENTOR_ACCESS_TOKEN = 'mentor-access-token';
export const ACCESS_TOKEN = 'access-token';
export const PENDING_INVITATION_KEY = 'pending_invitation_id';

export const UPLOAD_FILE_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
} as const;

export const RESERVED_SUBDOMAINS = ['www', 'admin', 'api', 'support', 'app', 'student', 'mentor'];

export const PLATFORM_DEFAULT_COLOR_PALETTE = {
  accent: {
    primary: '#2079CC',
    success: '#22C55E',
    warning: '#FFAB00',
    error: '#FF5630',
  },
  background: {
    light: {
      paper: '#FFFFFF',
      default: '#FFFFFF',
      neutral: '#F4F6F8',
      footer: '#F4F6F8',
    },
    dark: {
      paper: '#212B36',
      default: '#1e252e',
      neutral: '#919eab1f',
      footer: '#1e252e',
    },
  },
  text: {
    light: {
      primary: '#212B36',
      secondary: '#637381',
      disabled: '#919EAB',
    },
    dark: {
      primary: '#FFFFFF',
      secondary: '#919EAB',
      disabled: '#637381',
    },
  },
};

export const PLATFORM_DEFAULT_BRAND = {
  primary: '#2079CC',
  background: { light: '#F9FAFB', dark: '#1E252E' },
  logoFont: { source: 'google', family: 'Inter' } as PlatformBrandFont,
};
